// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mbt[data-v-47f2331b]{margin-bottom:1.5rem}.layout-wrp[data-v-47f2331b]{width:7.5rem;min-height:100%;display:flex;flex-direction:column;overflow:auto;margin:0 auto}.layout-wrp .nuxt-child[data-v-47f2331b]{flex-grow:1;background:#f3f3f3}.placeholder[data-v-47f2331b]{width:100%;height:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
